import { BillingCalculationDiscountDto } from "@app/modules/shared/model/billing/calculate/billing-calculation-discount.dto";
import { BillingLineDiscountDto } from "@app/modules/shared/model/billing/billing-line-discount.dto";
import { BillingDiscountDto } from "@app/modules/shared/model/billing/billing-discount.dto";

export class BillingCalculationExpenseDto {
  net_unit_amount: number;
  line_amount: number;
  document_amount: number;
  vat_amount: number;
  temp_vat_amount: number;
  calculationDiscount: BillingCalculationDiscountDto;
  lineExpenses: Array<BillingLineDiscountDto>;
  expenses: Array<BillingDiscountDto>;
}
